export const freewave1 = {
  'images': [],
  'mainFeatures': [
    'Nano Graphite Coating with Premium Nature Rubber',
    'Steel Spoiler Design for Clear Vision during High-Speed Driving',
  ],
  'material': [
    'Rubber: Premium Nature Rubber',
    'Steel: SPCC, Electrostatic Powder Coating',
    'Rivet: Steel Rivet',
    'Plastic (Spacer & Adapter): POM',
    'Stainless Steel Backing: SUS410 (Optional)',

  ],
  'featureIcons': ["02", "03", "05"],
  'otherFeatures': ["01", "02"],
  'specification': [
    { "inch": "16", "mm": "400", "claw": "4", "width": "6", "thickness": "1.0" },
    { "inch": "18", "mm": "450", "claw": "6", "width": "6", "thickness": "1.0" },
    { "inch": "19", "mm": "475", "claw": "6", "width": "6", "thickness": "1.0" },
    { "inch": "20", "mm": "500", "claw": "6", "width": "6", "thickness": "1.0" },
    { "inch": "21", "mm": "530", "claw": "8", "width": "6", "thickness": "1.0" },
    { "inch": "22", "mm": "560", "claw": "8", "width": "6", "thickness": "1.0" },
    { "inch": "23", "mm": "580", "claw": "8", "width": "6", "thickness": "1.0" },
    { "inch": "24", "mm": "600", "claw": "8", "width": "6", "thickness": "1.0" }
  ],
  'adapters': ["a7", "b", "c", "b1", "b3", "b6", "c1", "d2", "d4", "f", "g1", "pc", "s", "s1", "f3"]
}
